export const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');
export const lipnoCardRegex = /^[A-Z0-9]{8}-[A-Z0-9]{3}-[A-Z0-9]{3}/g;
